import BaseRailsRequestController from "./base_rails_request_controller";

// Connects to data-controller="shipment-item"
export default class extends BaseRailsRequestController {
  static targets = ["checkbox", "length", "width", "height"];
  static values = {
    url: String,
    stackableModal: Boolean,
    lengthModal: Boolean,
    errorMessage: String,
    height: { type: Number, default: 0 },
    width: { type: Number, default: 0 },
    length: { type: Number, default: 0 },
  };

  initialize() {
    this.requestingModal = false;
  }

  connect() {
    const otherShipmentItems = document.querySelectorAll("[data-controller='shipment-item']");
    otherShipmentItems.forEach((item) => {
      if (item.dataset.shipmentItemLengthModalValue === "true") {
        this.lengthModalValue = true;
      }

      if (item.dataset.shipmentItemStackableModalValue === "true") {
        this.stackableModalValue = true;
      }
    });
  }

  checkboxTargetConnected(checkbox) {
    checkbox.dataset.disableModal = this.stackableModalValue;
  }

  stackableModalValueChanged(oldValue, newValue) {
    if (oldValue === newValue) return;

    const checkboxes = document.querySelectorAll("[data-shipment-item-target='checkbox']"); // Update all checkboxes in the document

    checkboxes.forEach((checkbox) => {
      checkbox.dataset.disableModal = !newValue;
    });
  }

  validateInput(event) {
    if (isNaN(event.data)) return;
    if (event.inputType === "deleteContentBackward") return;

    const value = parseFloat(event.target.value);
    const maxValue = parseFloat(event.target.max);

    if (value > maxValue) {
      event.target.value = maxValue; // Cap at maximum value
    }
  }

  onDimensionChange(event) {
    if (this.lengthModalValue) return;

    const dimension = event.target.dataset.shipmentItemTarget;
    const value = parseFloat(event.target.value);
    this[dimension + "Value"] = value;
  }

  lengthValueChanged(oldValue, newValue) {
    if (oldValue === newValue) return;

    this.validateLength();
  }

  heightValueChanged(oldValue, newValue) {
    if (oldValue === newValue) return;

    this.validateLength();
  }

  widthValueChanged(oldValue, newValue) {
    if (oldValue === newValue) return;

    this.validateLength();
  }

  validateLength() {
    if (this.lengthValue <= 0 && this.heightValue <= 0 && this.widthValue <= 0) return;

    if (this.requestingModal) return; // Avoid multiple requests

    if (this.lengthValue < this.heightValue || this.lengthValue < this.widthValue) {
      this.requestingModal = true;

      const url = new URL(this.urlValue, window.location.origin);
      url.searchParams.set("length", this.lengthValue);
      url.searchParams.set("width", this.widthValue);
      url.searchParams.set("height", this.heightValue);
      url.searchParams.set("element_id", this.element.id);

      this.fetchWithProgress("get", url, {
        responseKind: "turbo-stream",
      })
        .catch((error) => {
          console.error(error);
          window.dispatchEvent(new CustomEvent("flash:create", { detail: { type: "danger", message: this.errorMessageValue } }));
        })
        .finally(() => {
          this.requestingModal = false;
        });
    }
  }
}
